(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    class HeaderAccordion extends HTMLElement {
    constructor() {
      super();
      this.rootDetails = this.querySelector(':scope > details');
      this.rootSummary = this.rootDetails?.querySelector(':scope > summary');
      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeyUp = this.onKeyUp.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      if (!this.rootDetails || !this.rootSummary) return;

      this.rootDetails.addEventListener('toggle', () => this.updateRootState());
      this.querySelectorAll('.joyful-menu-accordion__item').forEach((details) => {
        details.addEventListener('toggle', () => this.updateAccordionState(details));
      });

      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keyup', this.onKeyUp);
      window.addEventListener('resize', this.onResize);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      this.removeEventListener('keyup', this.onKeyUp);
      window.removeEventListener('resize', this.onResize);
      document.body.classList.remove('overflow-hidden-tablet');
    }

    updateRootState() {
      const isOpen = this.rootDetails.open;
      this.rootSummary.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('overflow-hidden-tablet', isOpen);

      if (isOpen) {
        document.querySelectorAll('.header__inline-menu details[open], details-modal details[open]').forEach((details) => {
          details.open = false;
          details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        });
      } else {
        this.closeNestedItems();
      }
    }

    updateAccordionState(details) {
      const summary = details.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', String(details.open));

      if (!details.open) return;

      const parentList = details.closest('ul');
      parentList?.querySelectorAll(':scope > li > details[open]').forEach((sibling) => {
        if (sibling === details) return;
        sibling.open = false;
        sibling.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });
    }

    onDocumentClick(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (target.closest('#cart-icon-bubble, details-modal')) {
        this.close();
        return;
      }

      if (this.rootDetails.open && !this.contains(target)) this.close();
    }

    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      const target = event.target;
      if (!(target instanceof Element)) return;

      const nestedOpen = target.closest('.joyful-menu-accordion__item[open]');
      if (nestedOpen) {
        nestedOpen.open = false;
        nestedOpen.querySelector(':scope > summary')?.focus();
        return;
      }

      this.close(true);
    }

    onResize() {
      if (window.matchMedia('(min-width: 990px)').matches) this.close();
    }

    close(restoreFocus = false) {
      if (!this.rootDetails?.open) return;
      this.rootDetails.open = false;
      if (restoreFocus) this.rootSummary?.focus();
    }

    closeNestedItems() {
      this.querySelectorAll('.joyful-menu-accordion__item[open]').forEach((details) => {
        details.open = false;
        details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
      });
    }
  }

  if (!customElements.get('header-accordion')) {
    customElements.define('header-accordion', HeaderAccordion);
  }
  } catch(e) { console.error(e); }
})();

})();
